import React, { useEffect, useContext, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useLongPress } from 'use-long-press'
import Header from './Header'
import Footer from './Footer'
import ManageListModal from './modal/ManageListModal'
import AddListModal from './modal/AddListModal'
import EditListModal from './modal/EditListModal'
import Loading from './Loading'
import { GlobalContext } from '../context/GlobalState'

const Main = () => {
  const context = useContext(GlobalContext)
  const navigate = useNavigate()
  const { user, lists, items, getAll } = context
  const [ showModal, setShowModal ] = useState(false)
  const [ showEditModal, setShowEditModal ] = useState(false)
  const [ showManageListModal, setShowManageListModal ] = useState(false)
  const [ selectedList, setSelectedList ] = useState(null)

  useEffect(() => {
    if (user == null) {
      navigate('/login')
    }
    else {
      getAll()
    }
    //eslint-disable-next-line
  }, [])

  /* bring up manage list modal when long press */
  const bind = useLongPress(e => {
    setSelectedList(lists.filter(list => list.listID === e.target.getAttribute('name'))[0])
    setShowManageListModal(true)
    }, {
        threshold: 500, 
        cancelOnMovement: true,
        cancelOutsideElement: true,
      })

  if(user == null || lists == null || items == null) //DO WE WANT THIS SPINNER WHEN OFFLINE MODE?
    return <Loading />
  return (
    <div>
      <Header />
      <main>
        <div className="page-header">
          <h5>My Lists</h5>
          <p>{lists.length} total</p>
        </div>
        <ul className="list-holder" role="list">
          {lists.map(list => (
            <Link to={`/list/${list.listID}`} key={list.listID} draggable="false">
              <li className="list-item" name={list.listID} {...bind()}>{list.listName}
                { list.hasBudget === 'Y' && <i className="fas fa-comment-dollar" id="money-icon"></i> }
                { list.shared === 'Y' && <i className="fas fa-user-friends" id="users-icon"></i>}
                { list.hasBudget === 'Y' ? <span className="count-span">${list.budgetAmt}</span> :
                  <span className="count-span">{items.filter(item => item.listID === list.listID).length} items</span>
                }
              </li>
            </Link>
          ))}
        </ul>
        <button className="standard_bttn" onClick={() => setShowModal(true) }>
          <i className="fas fa-plus-circle"></i> Add New List</button>
      </main>
      <Footer />
      <AddListModal showModal={showModal} setShowModal={setShowModal} />
      <EditListModal showModal={showEditModal} setShowModal={setShowEditModal} selectedList={selectedList} setSelectedList={setSelectedList} />
      <ManageListModal showManageListModal={showManageListModal} setShowManageListModal={setShowManageListModal} setShowEditModal={setShowEditModal} selectedList={selectedList} />
    </div>
  )
}

export default Main